import {
  AutoLockFormsLevelType,
  FormNames,
  NonBorrowerInfoFieldNames,
} from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const formFields = [
  ...addressFormFields,
  {
    name: 'firstName',
    label: 'First Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'middleName',
    label: 'Middle Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'suffix',
    label: 'Suffix',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'email',
    label: 'Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: NonBorrowerInfoFieldNames.CELL_PHONE_NUMBER,
    label: 'Cell Phone Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'ssn',
    label: 'Social Security Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'dateOfBirth',
    label: 'Date of Birth',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'relation',
    label: 'Relationship',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'maritalStatus',
    label: 'Marital Status',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'ownershipInterest',
    label: 'Ownership Interest',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isTrusteeOfTrust',
    label: 'Is Trustee of Trust',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'spouseFirstName',
    label: 'Spouse First Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'spouseLastName',
    label: 'Spouse Last Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'spouseEmail',
    label: 'Spouse Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'fhaEligible',
    label: 'FHA Eligible',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const nonBorrowerInfoForm = {
  name: FormNames.NON_BORROWER_INFO,
  label: 'Non Borrower',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
